export function setPrettyNameForPropDef(propertyDef: any) {
  if (propertyDef.properties) {
    propertyDef.properties.forEach(property => {
      if (
        property.name === 'Type' ||
        (property.name === 'Datatype' && !property.customList) ||
        property.name === 'Status'
      ) {
        property.refName = prettyName(property.refName);
      }
    });
  }
}

export function prettyName(uglyName: string, replaceAll?: boolean): string {
  if (!uglyName) {
    return '';
  }
  if (uglyName === 'INT') {
    return 'Integer';
  }
  if (uglyName === 'FLOAT') {
    return 'Decimal';
  }
  uglyName = replaceAll ? uglyName.replaceAll('_', ' ') : uglyName.replace('_', ' ');
  return uglyName.substring(0, 1).toUpperCase() + uglyName.substring(1).toLowerCase();
}
